<template>
  <vxe-toolbar class="bg-white-color p-16px">
    <template #buttons>
      <div class="h-input-group">
        <Select :datas="monthList" v-model="params.start" :deletable="false"/>
        <span class="h-input-addon">至</span>
        <Select :datas="monthList" v-model="params.end" :deletable="false"/>
      </div>
      <!-- <DatePicker v-model="params.start" :clearable="false" :option="{end:params.end}"/>
      <span class="mx-8px">至</span>
      <DatePicker v-model="params.end" :clearable="false" :option="{start:params.start}"/> -->
      <Button @click="loadList()" class="mx-8px" color="primary" icon="fa fa-search">查询</Button>
    </template>
    <template #tools>
      <vxe-button @click="printList()" content="打印" icon="fa fa-print"/>
      <vxe-button @click="exportExcel" content="导出" icon="fa fa-download"/>
    </template>
  </vxe-toolbar>
  <div class="flex-1 h-0px overflow-y bg-white-color">
    <vxe-table ref="xTable" :data="emList" class="mx-16px mb-8px" border :highlight-current-row="false">
      <vxe-column title="编码" field="code"/>
      <vxe-column title="客户名称" field="name"/>
      <vxe-column title="收入总额" field="sr" align="right" formatter="toMoney"/>
      <vxe-column title="支出总额" field="zc" align="right" formatter="toMoney"/>
      <vxe-column title="收入笔数" field="srbs" align="right"/>
      <vxe-column title="支出笔数" field="zcbs" align="right"/>
    </vxe-table>
    <div class="pl-20px">
      <div class="red-color font-bold">提示：</div>
      内部转账，不计入收支
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "customerSummary"
}
</script>

<script setup>
import {ref} from "vue";
import manba from "manba";
import {useStore} from "vuex";
import CashierReport from "@/api/CashierReport";
import {layer} from "@layui/layer-vue";
import { values } from 'xe-utils';
import Checkout from "@/api/checkout";

const store = useStore();
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format("YYYY-MM"));
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format("YYYY-MM"));

const emList = ref([]);
const xTable = ref(null);

const params = ref({
  start: startDate,
  end: endDate,
})

const summaryCol = ['sr', 'zc', 'srbs', 'zcbs'];

const aggregateData = ref([])

const monthList = ref([]);
Checkout.list().then(({data}) => {
  monthList.value = data.map(val => {
    // return {key: val.checkYear + "-" + val.checkMonth, title: val.checkYear + "年" + val.checkMonth + "月"}
    //jxd,处理弹出的期间未选中
    const month = val.checkMonth < 10 ? '0' + val.checkMonth : val.checkMonth;
    return {key: val.checkYear + "-" + month, title: val.checkYear + "年" + month + "月"}
  })
})

 //jxd导出
 const exportExcel = () => {
    const $table = xTable.value
    if ($table) {
      $table.exportData({
          filename: `资金报表-按客户`,
          type: 'csv',
          isHeader: true,
          isFooter: true,
        });
    }
  }

const tablePrint = {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        `
      }

const printList = () => {
  const $xTable = xTable.value;
	// let headerHtml = `<h3>内部转账</h3>
	// 		<div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
	// 			<span> </span>
	// 			<span>${startDate.value} 至 ${endDate.value}</span>
	// 			<span> 单位：元 </span>
	// 		</div>
	// 		`;
	// let footerHtml = `<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：${store.state.currentAccountSets.companyName}</div>`;
	if ($xTable) {
    $xTable.print({	 	
      // 打印样式设置
      style: tablePrint,
      // 打印指定列
      // columns: [
      //   { field: 'transferDate' },
      //   { field: 'digest' },
      //   { field: 'billDate' },
      //   { field: 'outAccount' },
      //   { field: 'inAccount' },
      //   // { field: 'deptName' },
      //   // { field: 'projectName' },
      //   { field: 'amount' },
      //   { field: 'remark' },
      // ],
      // 打印之前拼接自定义模板
      // beforePrintMethod: ({ content }) => {
      //   // 打印之前，返回自定义的 html 内容
      //   return headerHtml + content + footerHtml
      // }
    })
  }
}

const loadList = () => {
  const loadId = layer.load(1);
  CashierReport.customerSummary(params.value).then(({data}) => {
    let sr = 0;
    let zc = 0;
    let srbs = 0;
    let zcbs = 0;
    (data || []).forEach(val => {
      sr+=val.sr;
      zc+=val.zc;
      srbs+=val.srbs;
      zcbs+=val.zcbs;
    });
    data.push({name: '总计', sr, zc, srbs, zcbs})
    emList.value = data;
  }).finally(() => layer.close(loadId))
}
loadList()
</script>
